export default __webpack_public_path__ + "static/media/camelot.7a504a67.webp";